'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import { CustomLink } from '@/app/_components/CustomLink';
import { readTappedThumbnail, rememberGiftPreview } from '@/app/_components/GiftCard/giftPreview';
import { Image } from '@/components/client';
import { Rating } from '@/components/molecule/Rating';
import { BREAKPOINTS, DONATION_ROUTES } from '@/constants';
import { useMediaQuery } from '@/hooks/useMediaQuery';
interface RecentOrderGiftListItemProps {
  mainImageUrl: string;
  institutionName: string;
  productNumber: string;
  slugId: string;
  productName: string;
  reviewCount: number;
  reviewRating: number;
  createAt: string;
  priority?: boolean;
}
export const RecentOrderGiftListItem = t0 => {
  const $ = _c(51);
  const {
    mainImageUrl,
    institutionName,
    productNumber,
    slugId,
    productName,
    reviewCount,
    reviewRating,
    createAt,
    priority
  } = t0;
  const isDesktop = useMediaQuery(BREAKPOINTS.DESKTOP);
  let t1;
  if ($[0] !== createAt) {
    t1 = getTimeAgo(createAt);
    $[0] = createAt;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const timeAgo = t1;
  let t2;
  if ($[2] !== productNumber || $[3] !== slugId) {
    t2 = DONATION_ROUTES.GIFTS_DETAIL.pathname({
      productNumber: slugId ?? productNumber
    });
    $[2] = productNumber;
    $[3] = slugId;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = `${productName} 상세 페이지로 이동`;
  let t4;
  if ($[5] !== institutionName || $[6] !== mainImageUrl || $[7] !== productName || $[8] !== productNumber || $[9] !== slugId) {
    t4 = event => {
      rememberGiftPreview({
        productNumber: slugId ?? productNumber,
        mainImageUrl,
        thumbnailSrc: readTappedThumbnail(event.currentTarget),
        productName,
        institutionName
      });
    };
    $[5] = institutionName;
    $[6] = mainImageUrl;
    $[7] = productName;
    $[8] = productNumber;
    $[9] = slugId;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = cn("group flex w-[22rem] items-center justify-between gap-20 rounded-xlarge", "transition-opacity duration-200 ease-out", "focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-B-500", "active:opacity-80", "mobile-tablet:w-[20.9375rem] mobile-tablet:justify-start mobile-tablet:gap-16 mobile-tablet:pr-32");
    t6 = cn("relative size-140 shrink-0 overflow-hidden rounded-xlarge bg-Gray-black/10", "mobile-tablet:size-104");
    $[11] = t5;
    $[12] = t6;
  } else {
    t5 = $[11];
    t6 = $[12];
  }
  let t7;
  if ($[13] !== mainImageUrl || $[14] !== priority || $[15] !== productName) {
    t7 = <Image src={mainImageUrl} alt={productName} width={280} height={280} preload={priority} sizes={`${BREAKPOINTS.MOBILE_TABLET} 104px, 140px`} className="size-full object-cover" />;
    $[13] = mainImageUrl;
    $[14] = priority;
    $[15] = productName;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div aria-hidden="true" className="absolute inset-0 bg-Gray-black/0 transition-colors duration-300 ease-out group-hover:bg-Gray-black/5" />;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t7) {
    t9 = <div className={t6}>{t7}{t8}</div>;
    $[18] = t7;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = cn("font-600 text-Gray-600 typo-body4", "mobile-tablet:font-400 mobile-tablet:typo-caption1");
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== institutionName) {
    t11 = <p className={t10}>{institutionName}</p>;
    $[21] = institutionName;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = cn("line-clamp-2 min-h-[2lh] pt-2 font-500 text-Gray-800 typo-body2", "mobile-tablet:font-400 mobile-tablet:typo-body4");
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== productName) {
    t13 = <p className={t12}>{productName}</p>;
    $[24] = productName;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  const t14 = isDesktop ? 16 : 12;
  let t15;
  if ($[26] !== reviewRating || $[27] !== t14) {
    t15 = <Rating value={reviewRating} size={t14} />;
    $[26] = reviewRating;
    $[27] = t14;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  let t16;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = cn("pt-6 font-400 text-Gray-600 typo-caption1", "mobile-tablet:typo-caption2");
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  let t17;
  if ($[30] !== reviewCount) {
    t17 = reviewCount?.toLocaleString();
    $[30] = reviewCount;
    $[31] = t17;
  } else {
    t17 = $[31];
  }
  let t18;
  if ($[32] !== t17) {
    t18 = <span className={t16}>({t17})</span>;
    $[32] = t17;
    $[33] = t18;
  } else {
    t18 = $[33];
  }
  let t19;
  if ($[34] !== t15 || $[35] !== t18) {
    t19 = <div className="flex items-center gap-4">{t15}{t18}</div>;
    $[34] = t15;
    $[35] = t18;
    $[36] = t19;
  } else {
    t19 = $[36];
  }
  let t20;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = cn("whitespace-nowrap pt-2 font-600 text-O-400 typo-body3", "mobile-tablet:font-400 mobile-tablet:typo-caption1");
    $[37] = t20;
  } else {
    t20 = $[37];
  }
  let t21;
  if ($[38] !== timeAgo) {
    t21 = <p className={t20}>{timeAgo} 전에 주문했어요!</p>;
    $[38] = timeAgo;
    $[39] = t21;
  } else {
    t21 = $[39];
  }
  let t22;
  if ($[40] !== t11 || $[41] !== t13 || $[42] !== t19 || $[43] !== t21) {
    t22 = <div className="flex flex-1 flex-col">{t11}{t13}{t19}{t21}</div>;
    $[40] = t11;
    $[41] = t13;
    $[42] = t19;
    $[43] = t21;
    $[44] = t22;
  } else {
    t22 = $[44];
  }
  let t23;
  if ($[45] !== t2 || $[46] !== t22 || $[47] !== t3 || $[48] !== t4 || $[49] !== t9) {
    t23 = <li><CustomLink href={t2} aria-label={t3} onClick={t4} className={t5}>{t9}{t22}</CustomLink></li>;
    $[45] = t2;
    $[46] = t22;
    $[47] = t3;
    $[48] = t4;
    $[49] = t9;
    $[50] = t23;
  } else {
    t23 = $[50];
  }
  return t23;
};
const getTimeAgo = (date: string) => {
  if (typeof date !== 'string') return '-';

  //* 현재 시간과 주어진 날짜를 사용자의 로컬 시간대에서 계산
  const now = new Date();
  //* 입력으로 받는 iso는 한국 시간이므로 국제 표준시(utc)로 변경하려면 offset을 붙여줘야 함
  const targetDate = new Date(date + '+09:00');

  //* 시간 차이 계산 (밀리초)
  const diff = now.getTime() - targetDate.getTime();
  const seconds = Math.floor(diff / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);

  //* 음수인 경우 (미래 날짜) 처리
  if (seconds < 0) {
    return '방금';
  }
  if (seconds < 60) {
    return `${seconds}초`;
  }
  if (minutes < 60) {
    return `${minutes}분`;
  }
  return `${hours}시간`;
};